import { Link } from 'react-router-dom'
import { useState } from 'react'
import { RefreshCw } from 'lucide-react'

// OAuth Client IDs
const GOOGLE_CLIENT_ID = '163927207983-uufacn3k24f2ii1jv011q8beuuvflb27.apps.googleusercontent.com'
const KAKAO_CLIENT_ID = 'eeccaf2935773675378ba9bf0444bca0'

// Get OAuth redirect URI
const getRedirectUri = (provider: string) => {
  const baseUrl = window.location.origin
  return `${baseUrl}/auth/${provider}/callback`
}

export default function LoginPage() {
  const [isLoading, setIsLoading] = useState<'google' | 'kakao' | null>(null)

  const handleGoogleLogin = () => {
    setIsLoading('google')
    const redirectUri = getRedirectUri('google')
    const scope = 'openid email profile'
    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${GOOGLE_CLIENT_ID}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code&scope=${encodeURIComponent(scope)}&access_type=offline&prompt=consent`

    window.location.href = authUrl
  }

  const handleKakaoLogin = () => {
    setIsLoading('kakao')
    const redirectUri = getRedirectUri('kakao')
    const authUrl = `https://kauth.kakao.com/oauth/authorize?client_id=${KAKAO_CLIENT_ID}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code`

    window.location.href = authUrl
  }

  return (
    <div className="min-h-screen bg-bg-primary flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex items-center gap-2 text-accent-gold font-bold text-2xl">
            <span className="text-3xl">◆</span>
            <span>AI Studio</span>
          </Link>
          <p className="mt-2 text-text-secondary">AI 콘텐츠 제작 스튜디오</p>
        </div>

        {/* Login Card */}
        <div className="card p-8">
          <h1 className="text-2xl font-bold text-center mb-6">로그인</h1>

          <div className="space-y-4">
            {/* Google Login */}
            <button
              onClick={handleGoogleLogin}
              disabled={isLoading !== null}
              className="w-full flex items-center justify-center gap-3 px-4 py-3 bg-white text-gray-800 rounded-lg font-medium hover:bg-gray-100 transition-colors disabled:opacity-70 disabled:cursor-not-allowed"
            >
              {isLoading === 'google' ? (
                <RefreshCw className="w-5 h-5 animate-spin" />
              ) : (
                <svg className="w-5 h-5" viewBox="0 0 24 24">
                  <path
                    fill="#4285F4"
                    d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                  />
                  <path
                    fill="#34A853"
                    d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                  />
                  <path
                    fill="#FBBC05"
                    d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                  />
                  <path
                    fill="#EA4335"
                    d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                  />
                </svg>
              )}
              Google로 시작하기
            </button>

            {/* Kakao Login */}
            <button
              onClick={handleKakaoLogin}
              disabled={isLoading !== null}
              className="w-full flex items-center justify-center gap-3 px-4 py-3 bg-[#FEE500] text-[#191919] rounded-lg font-medium hover:bg-[#FDD800] transition-colors disabled:opacity-70 disabled:cursor-not-allowed"
            >
              {isLoading === 'kakao' ? (
                <RefreshCw className="w-5 h-5 animate-spin" />
              ) : (
                <svg className="w-5 h-5" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M12 3c-5.52 0-10 3.59-10 8 0 2.83 1.87 5.32 4.69 6.73-.21.76-.77 2.76-.88 3.19-.14.53.19.52.4.38.17-.11 2.65-1.8 3.72-2.54.67.1 1.37.15 2.07.15 5.52 0 10-3.59 10-8s-4.48-8-10-8z"
                  />
                </svg>
              )}
              카카오로 시작하기
            </button>
          </div>

          <div className="mt-6 text-center text-sm text-text-tertiary">
            <p>
              로그인하면{' '}
              <a href="#" className="text-accent-gold hover:underline">이용약관</a>
              {' '}및{' '}
              <a href="#" className="text-accent-gold hover:underline">개인정보처리방침</a>
              에 동의하게 됩니다.
            </p>
          </div>
        </div>

        {/* Back to Home */}
        <div className="mt-6 text-center">
          <Link to="/" className="text-text-secondary hover:text-text-primary transition-colors">
            ← 홈으로 돌아가기
          </Link>
        </div>
      </div>
    </div>
  )
}
